export const TAGS_COLORS = [
  '#FFFFFF',
  '#F54336',
  '#EA1E63',
  '#9C27B0',
  '#2296F3',
  '#13C2C2',
  '#4CAF50',
  '#CDDD39',
  '#FFEB3B',
  '#FF9802',
  '#795548',
  '#000000',
  '#DDDDDD',
  '#FFB5AF',
  '#FFC1D6',
  '#F6BFFF',
  '#BEE2FF',
  '#ABE0DF',
  '#C5EBC6',
  '#F5FACA',
  '#FCE2BA',
  '#E9CCC2',
  '#BDB9B9',
];
